import { combineReducers } from "@reduxjs/toolkit";

import activitiesReducer from "Reducers/metrics/activities.slice";
import settingsReducer from "Reducers/metrics/settings.slice";

export default combineReducers({
  settings: settingsReducer,
  activities: activitiesReducer
});
